import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '@vsolv/vectors-ui/alert';
import { DialogComponent } from '@vsolv/vectors-ui/dialog';
import { Policy } from '@wsphere/warranties/domain';
import { PolicyService } from '../../services';
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-restore-policy-dialog',
  templateUrl: './restore-policy.dialog.html',
  standalone: false,
})
export class RestorePolicyDialog {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private policySvc: PolicyService,
    private toastSvc: ToastService
  ) {}
  @ViewChild(DialogComponent) dialog!: DialogComponent;

  @Input() policy?: Policy.Model | null;

  saving = false;

  open() {
    this.dialog.open();
  }

  close() {
    this.dialog.close();
  }

  cancel() {
    this.dialog.close();
  }

  async restore() {
    this.saving = true;

    if (!this.policy) throw new Error('Unable to restore policy, policy not found');

    if (this.policy.status !== Policy.Status.ARCHIVED && this.policy.status !== Policy.Status.RUNOFF) {
      throw new Error(`Unable to restore policy with status: ${this.policy.status}`);
    }

    const newPolicy = await this.policySvc.duplicate(this.policy.id, true).catch(({ error }) => {
      this.toastSvc.show({
        type: 'error',
        title: 'Something went wrong',
        text: error.message,
      });

      this.close();
      this.saving = false;
    });

    const newPolicyId = newPolicy && typeof newPolicy === 'object' && 'id' in newPolicy ? newPolicy.id : undefined;
    if (newPolicyId) {
      this.toastSvc.show({
        type: 'success',
        title: 'Restored policy',
        text: '<strong>' + this.policy?.title + '</strong> has been successfully restored.',
      });

      this.close();
      this.saving = false;
      this.policySvc.refreshPolicy(newPolicyId);
      this.policySvc.clearPlan();

      // Absolute: from the policies list the host route consumes no segments, so '../' escapes /policies
      const childPath = this.route.snapshot.firstChild?.routeConfig?.path;
      this.router.navigate(['/policies', newPolicyId, ...(childPath ? [childPath] : [])]);
    }
  }
}
